import { useSuspenseQuery } from '@tanstack/react-query';
import { useSimulatedRoleContext } from '../../context/contexts';
import { Hasher } from '../hasher';
import { hashString, Role } from '../types';
import { DomainDependenciesService } from './services';

const domainDependenciesQueryKey = ['domain-dependencies'];
export const getDomainDependenciesQueryKey = (
  domainDependenciesService: DomainDependenciesService,
  simulatedRole: Role | null
) => [
  ...domainDependenciesQueryKey,
  hashString([
    ...domainDependenciesService.getDeps(),
    Hasher.hash(simulatedRole),
  ]),
];

export const useDomainDependencies = (
  domainDependenciesService: DomainDependenciesService
) => {
  const simulateRole = useSimulatedRoleContext();
  return useSuspenseQuery({
    queryKey: getDomainDependenciesQueryKey(
      domainDependenciesService,
      simulateRole
    ),
    queryFn: async () => {
      const result = await domainDependenciesService.get(simulateRole);
      return result;
    },
  });
};
